import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import ProjectsTab from "../components/admin/ProjectsTab";
import IntegrationsTab from "../components/admin/IntegrationsTab";
import TemplatesTab from "../components/admin/TemplatesTab";

type Tab = "projects" | "integrations" | "templates";

function AdminPage() {
  const [activeTab, setActiveTab] = useState<Tab>("projects");
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Back button */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex items-center">
            <Link
              to="/"
              className="inline-flex items-center text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"
            >
              <ArrowLeft className="h-4 w-4 mr-1" />
              Back to Architect
            </Link>
          </div>
        </div>

      {/* Main Content with padding for fixed header */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        {/* Tabs */}
        <div className="border-b border-gray-200 dark:border-gray-700 mb-6">
          <nav className="-mb-px flex space-x-8">
            <button
              onClick={() => setActiveTab("projects")}
              className={`py-2 px-1 border-b-2 font-medium text-sm ${
                activeTab === "projects"
                  ? "border-blue-500 text-blue-600 dark:border-blue-400 dark:text-blue-300"
                  : "border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600"
              }`}
            >
              Projects
            </button>
            <button
              onClick={() => setActiveTab("integrations")}
              className={`py-2 px-1 border-b-2 font-medium text-sm ${
                activeTab === "integrations"
                  ? "border-blue-500 text-blue-600 dark:border-blue-400 dark:text-blue-300"
                  : "border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600"
              }`}
            >
              Integrations
            </button>
            <button
              onClick={() => setActiveTab("templates")}
              className={`py-2 px-1 border-b-2 font-medium text-sm ${
                activeTab === "templates"
                  ? "border-blue-500 text-blue-600 dark:border-blue-400 dark:text-blue-300"
                  : "border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600"
              }`}
            >
              Templates
            </button>
          </nav>
        </div>

        {/* Content */}
        {activeTab === "projects" ? (
          <ProjectsTab searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        ) : activeTab === "integrations" ? (
          <IntegrationsTab searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        ) : (
          <TemplatesTab searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        )}

        {/* Alert */}
        <div className="mt-8 bg-gray-100 dark:bg-gray-800/20 border border-gray-200 dark:border-gray-800 text-gray-600 dark:text-gray-300 px-6 py-4 rounded-md relative">
          MetaRouter employees (log in with your @metarouter.io email) have access to this panel. If you spot a bug or have a feature idea, ping me on Slack! This is an early MVP, so expect missing features and a few known bugs. 🚀 Mike P.
        </div>
      </div>
    </div>
  );
}

export default AdminPage;
